export default __webpack_public_path__ + "static/truck_w.cb3cdfa1330276158005f1a7a96ba853.png";